export const SelectedOfferOverlayUat = {
  title: 'offerView.selectedOfferOverlay.title'
}
